import { useGetMeetingIntelligenceUserSettingsQuery } from '../api'

/**
 * Hook to check if AI notetaker is enabled.
 *
 * @param {number | undefined} [eventTypeId]
 * @returns {boolean | null}
 */
export const useIsAiNotetakerEnabled = (eventTypeId) => {
  const { data: miSettings } = useGetMeetingIntelligenceUserSettingsQuery()

  // If notetaker not enabled on account, don't send attribute
  if (!miSettings?.miEnabled || miSettings?.adminDisabledNotetaker) {
    return null
  }

  // Profile-level shares should not include is_ai_notetaker_enabled property
  if (eventTypeId === undefined || eventTypeId === null) {
    return null
  }

  // If calendly meetings auto-recording is turned off globally
  if (miSettings?.autoRecordV3Calendly === false) {
    return null
  }

  // Check if ET is in the include list
  const includeList = miSettings?.autoRecordV3CalendlyIncludeList || []

  // If include list is empty, notetaker is effectively not enabled
  if (includeList.length === 0) {
    return null
  }

  return includeList.includes(eventTypeId)
}
